/* ドロップダウンメニュー
---------------------------------------------- */
export const DROP_DOWN = {
  init: function (elements) {
    const hasChildren = document.querySelectorAll('.menu-item-has-children')

    hasChildren.forEach(ele => {
      const anchor = ele.querySelector('a')
      if (anchor.href.match('#')) {
        anchor.setAttribute('href', 'javascript:void(0)')
      }
    })

    const parent = document.querySelectorAll('.menu-item-has-children')
    const node = Array.prototype.slice.call(parent, 0)
    const body = document.querySelector('body')
    const isSPclass = 'is-gnav-open'

    node.forEach(function (element) {
      element.addEventListener(
        'mouseover',
        function () {
          if (!body.classList.contains(isSPclass)) {
            element.querySelector('.sub-menu').classList.add('is-slide-down')
          }
        },
        false,
      )
      element.addEventListener(
        'mouseout',
        function () {
          element.querySelector('.sub-menu').classList.remove('is-slide-down')
        },
        false,
      )
    })
  },
}
